import { useDispatch, useSelector } from "react-redux"
import { removeErrorMessage, removeSuccessMessage } from "../../../../store/ActionAlertsStore";

const ActionAlerts = () => {
    const dispatch = useDispatch();
    const errorMessages = useSelector((state:any) => state.actionAlerts.errorMessages);
    const successMessages = useSelector((state:any) => state.actionAlerts.successMessages);

    const removeError = (message:string) => {
        dispatch(removeErrorMessage(message))
    }

    const removeSuccess = (message:string) => {
        setTimeout(() => {
            dispatch(removeSuccessMessage(message))
        }, 4000)
        
    }

    return (
        <>
            <div className="action-alerts">
                {errorMessages.map((message:string, index:number) => {
                    removeError(message)
                    return <div className="alert alert-danger" role="alert" key={'alert-error-'+index}>
                        { message }
                    </div>
                })}

                {successMessages.map((message:string, index:number) => {
                    removeSuccess(message)
                    return <div className="alert alert-success" role="alert" key={'alert-success-'+index}>
                        { message }
                    </div>
                })}
            </div>
        </>
    )
}

export default ActionAlerts;